import React from 'react';

const SpinnerButton = ({onClick, loading, name, disabled = false}) => {
  return (
      <button
          className={`btn btn-round btn-cw btn-yellow my-md-1 my-2 w-25`}
          style={{padding: !loading ? '16px 0' : '12.5px 0', transition: 'none'}}
          onClick={onClick}
        disabled={disabled === true}>
          {loading &&
          <svg width="20" height="20" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"
               stroke="#fff">
              <g fill="none" fillRule="evenodd">
                  <g transform="translate(1 1)" strokeWidth="2">
                      <circle strokeOpacity=".5" cx="18" cy="18" r="18"></circle>
                      <path d="M36 18c0-9.94-8.06-18-18-18" transform="rotate(212.082 18 18)">
                          <animateTransform attributeName="transform" type="rotate" from="0 18 18"
                                            to="360 18 18" dur="1s"
                                            repeatCount="indefinite"></animateTransform>
                      </path>
                  </g>
              </g>
          </svg>
          }
          {!loading &&
          `${name}`
          }
      </button>
  )
};

export default SpinnerButton;
